import * as React from 'react'

export function ErrorIcon() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM51.8017 23.4777C53.1052 22.1741 55.2187 22.1741 56.5223 23.4777C57.8259 24.7813 57.8259 26.8948 56.5223 28.1983L44.7207 40L56.5224 51.8017C57.8259 53.1052 57.8259 55.2187 56.5224 56.5223C55.2188 57.8259 53.1053 57.8259 51.8017 56.5223L40 44.7206L28.1983 56.5223C26.8948 57.8259 24.7813 57.8259 23.4777 56.5223C22.1741 55.2187 22.1741 53.1052 23.4777 51.8017L35.2794 40L23.4777 28.1983C22.1742 26.8948 22.1742 24.7813 23.4777 23.4777C24.7813 22.1741 26.8948 22.1741 28.1984 23.4777L40 35.2793L51.8017 23.4777Z"
        fill="#EE3E3A"
      />
      <path
        fillRule="evenodd"
        d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM75.5556 40C75.5556 59.6368 59.6368 75.5556 40 75.5556C20.3632 75.5556 4.44444 59.6368 4.44444 40C4.44444 20.3632 20.3632 4.44444 40 4.44444C59.6368 4.44444 75.5556 20.3632 75.5556 40Z"
        fill="white"
      />
    </svg>
  )
}
